import { z } from 'zod'

export const resetPasswordSchema = z
  .object({
    password: z.string().min(1, 'Ce champ est requis'),
    passwordConfirmation: z.string().min(1, 'Ce champ est requis'),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Les mots de passe ne correspondent pas',
        path: ['passwordConfirmation'],
      })
    }
  })

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>
